import { Component, Input, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { Router, RouterModule } from '@angular/router';
import { environment } from 'src/environments/environment';
import { MediaService } from '../../services/mediaservice/media.service';

import { FormsModule } from '@angular/forms';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { CommonModule } from '@angular/common';
declare let $: any;
@Component({
  selector: 'app-news-updates',
  templateUrl: './news-updates.component.html',
  styleUrls: ['./news-updates.component.css'],
  standalone: true,
  imports: [FormsModule, RouterModule, CarouselModule,CommonModule]
})
export class NewsUpdatesComponent implements OnInit {

  @Input() mediaObject: any[] = [];
  showNewsAndUpdate = true;
  zoomOut = false;
  showSpinner = false;
  imageArray: any[] = [];
  showArrow = false;
  user: any;
  user_role: any;

  constructor(public router: Router, private mediaService: MediaService,) {
    this.user = JSON.parse(localStorage.getItem('user') || '');
    this.user_role = JSON.parse(this.user.user_role.user_roles)
    $("#imageModal").modal('show');
  }

  ngOnInit(): void {

    this.showSpinner = true;


    this.imageArray = [];

    this.mediaObject.forEach((data: any) => {
      if (data.type == 'image') {
        this.imageArray.push({
          image: `${environment.imageBaseURL}/${data.path}`,
          thumbImage: `${environment.imageBaseURL}/${data.path}`,
          isImage: true
        });
      } else {
        this.imageArray.push({
          video: `${environment.imageBaseURL}/${data.path}`,
          thumbImage: `${environment.imageBaseURL}/${data.path}`,
          isImage: false
        });
      }
    });

    // Reverse so the latest one is at index 0
    this.imageArray.reverse();
    if (this.imageArray.length == this.mediaObject.length) {
      if (this.imageArray.length == 1) {
        this.showArrow = false;
      }
      this.showSpinner = false;
    }
    $(document).ready(function () {

      $("#imageModal").modal('show');
    });
  }
  gotoGallery() {
    this.router.navigate(['/news-update-gallery']);
  }
  hideNewsAndUpdates() {
    alert("ok working")
    // this.showNewsAndUpdate = !this.showNewsAndUpdate;
    // localStorage.setItem('newsUpdateDate', new Date().toString());
  }

  imageOnClick(event: any) {

    $('body').css({ zoom: 0 });
  }

  lightboxClose(event: any) {
    $('body').css({ zoom: 0.8 });
  }
  deleteImage() {
    const imageId = this.mediaObject[0].id
    this.showSpinner = true;
    this.mediaService.deleteMedia(imageId).then((value) => {
      if (value.success) {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: `Imgae Deleted Successfully`,
          showConfirmButton: false,
          timer: 2000,
        });
      } else {

        Swal.fire({
          icon: 'error',
          title: 'Failed to delete image',
          text: value.message || 'An error occurred while deleting the image.',
          showConfirmButton: true
        });
      }
      window.location.reload();
      this.showSpinner = false;
    });
  }

  isavailablefeature(type: string): boolean {
    const user_role = JSON.parse(this.user.user_role.user_roles);
    const values = user_role?.upload_data?.data?.values;

    switch (type) {
      case "view":
        return values?.view ?? false;

      case "upload":
        return values?.accept ?? false;

      case "delete":
        return values?.reject ?? false;


      default:
        return false;
    }
  }

}
